<footer
  class="px-base md:px-base-desk flex flex-col gap-4 relative text-center pb-4 text-xs items-center 
    md:items-end md:justify-between md:w-full md:flex-row 
    {{ additionalClasses }}" >

  @if (!hideCustomFooter) {
    <p [innerHTML]="text"></p>
  }

  <div class="flex md:gap-12">
    <div class="flex flex-col gap-2">
      <span>{{ "Powered by" | translate }}</span>
      <img
        src="assets/images/Amazon.png"
        class="max-h-[1.5rem]"
        alt="Logo Amazon"
      />
    </div>

    <div class="flex flex-col gap-2">
      <span>{{ "Maded by" | translate }}</span>
      <div class="flex justify-between gap-6">
        <img
          src="assets/images/ActionAid.png"
          class="max-h-[1.5rem]"
          alt="Logo Action Aid"
        />
        <img
          src="assets/images/FRIC.png"
          class="max-h-[1.5rem]"
          alt="Logo FRIC"
        />
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <span>{{ "With the partecipation of" | translate }}</span>
      <img
        src="assets/images/Rame.png"
        class="max-h-[1.25rem] max-w-max"
        alt="Logo Rame"
      />
    </div>
  </div>

  @if (!hideMetaCredits) {
    <p class="flex flex-col gap-2 items-center md:items-end">
      {{ "Layout Design & Web Development" | translate }}<br />
      <a
        href="https://www.gruppometa.it/"
        title="Vai al sito web di GruppoMeta"
      >
        <img
          src="core/assets/images/logoMeta.svg"
          class="max-h-[1.5rem]"
          alt="Logo GruppoMeta"
        />
      </a>
    </p>
  }
</footer>
